import React, { useState } from 'react'
import moment from 'moment'
import IconMessage from './IconMessage'
import SelectOptionsMessage from './SelectOptionsMessage';
import AnnotationCommentDelete from './AnnotationCommentDelete';

const AnnotationCommentListItem = ({message, annotation, roleType, klass}) => {
  const resolutionMessage = ["Unresolved", "Resolved"].includes(message.action_taken);
  const optionSelectedMessage = message.action_taken == "Option_selected";
  const commentMessage = ["Commented", undefined].includes(message.action_taken);
  const commentedTime = moment(message.commented_at).format('MM/DD/YY');

  const commentBeforeLocked = annotation.locked_at != null ? message.commented_at > annotation.locked_at : true;

  // Any designer can delete any design related comments
  // this happens when moving from design --> design_review
  const sameUser = roleType == "area_director" ? message.role_type == roleType : true;

  const forDigitalJob = klass.jobType == 'DigitalJob';
  const forPromo = klass.jobType == 'Promo';
  const forCustomLabel = klass.jobType == 'CustomLabel';

  // add photo, remove photo stuff
  const messageIsGeneric = ['add_photo', 'add_article', 'remove_photo', 'remove_article', 'remove_pages', 'add_files'].includes(message.id.toString())

  const permanentDigitalMessage = forDigitalJob && ['add_files', 'cta'].includes(message.id.toString())

  const deletable = commentBeforeLocked && sameUser && !permanentDigitalMessage;

  const removeComment = () => {
    klass.deleteComment(message, messageIsGeneric)
  }

  const getInnerContent = (msg) => {
    switch (msg.id.toString()){
      case 'add_photo':
        const label = annotation.has_photos_with_captions ? 'Photos with Captions' : 'Photos'
        return <IconMessage label={label} link={`/annotations/${annotation.id}/assets`} description={'Click here to access photos'}/>;
      case 'add_article':
        const articleLink = roleType == 'area_director' ? `/article_jobs/${annotation.article_job_id}` : `${window.location.href.split('/annotations')[0]}/article_jobs/${annotation.article_job_id}`
        return <IconMessage label={'Article'} link={articleLink} description={'Click here to access article'}/>;
      case 'remove_photo':
        return <IconMessage label={'Photo'} description={'Please remove this photo'}/>;
      case 'remove_article':
        return <IconMessage label={'Article'} description={'Please remove this article'}/>;
      case 'remove_pages':
        return <IconMessage label={'Remove Pages'} description={`Remove pages ${annotation.pages.join(', ')}`}/>;
      case 'add_files':
        const desc = roleType == 'area_director' ? "Click here to upload files" : "Click here to access files"
        return <IconMessage label={'Add Files'} link={annotationAssetsUrl()} description={desc}/>;
      case 'cta':
        return (
          <SelectOptionsMessage
            label={"Please select a CTA"}
            disabled={roleType != "area_director"}
            handleSubmission={klass.saveOptionSelection}
            annotation={annotation}
            options={annotation.selectable_options}
            selectedOption={lastSelectedOption}
          />
        );
      default:
        if (msg.attachment) {
          if (deletable){
            return <img src={`${msg.attachment}`} />
          } else {
            // download doesn't work with IE11
            return (
              <a href={`${msg.attachment}`} download="attachment">
                <img src={`${msg.attachment}`} />
              </a>
            )
          }
        } else if (resolutionMessage) {
          const actionRole = ["Creative Director", "Ad Designer", "Pub Designer"].includes(msg.role_name) ? "Design" : msg.role_name
          return <small className="grey-text"><i>{commentedTime} {`${msg.action_taken} by ${actionRole}`}</i></small>
        }  else if (optionSelectedMessage) {
          return <small className="grey-text"><i>{commentedTime} Option selected by Area Director</i></small>
        } else {
          return <p className="text-left" dangerouslySetInnerHTML={{__html: msg.content}}></p>
        }
    }
  }

  const selection = annotation.messages.filter((msg) => msg.action_taken === "Option_selected").pop();
  const lastSelectedOption = selection ? selection.content : "";
  
  const annotationAssetsUrl = () => {
    if (roleType == 'area_director') {
      return `/annotations/${annotation.id}/assets`;
    } else if (forDigitalJob) {
      return `/digital_jobs/${klass.jobId}/annotations?view=files`;
    } else if (forPromo) {
      return `/store/promos/${klass.jobId}/annotation_files`;
    } else if (forCustomLabel) {
      return `/store/custom_labels/${klass.jobId}/annotation_files`;
    } else {
      return `/ad_design_jobs/${klass.jobId}/annotation_files`;
    }
  }

  let messageStyleClass = 'blue-message';
  switch (message.role_name) {
    case 'Area Director':
      messageStyleClass = 'grey-message';
      break;
    case 'CSR':
      messageStyleClass = 'orange-message';
      break;
  }
  const messageSide = messageStyleClass == 'blue-message' ? 'message--right' : 'message--left';
  const timeStampSide = messageStyleClass == 'blue-message' ? 'text-left' : 'text-right';

  if (!commentMessage) {
    messageStyleClass = '';
    switch (message.role_name) {
      case 'Area Director':
        messageStyleClass = 'text-left';
        break;
      default:
        messageStyleClass = 'text-right'
        break;
    }
  }

  if (message.attachment) {
    messageStyleClass += ' attachment';
  }
  // generic message for different types
  if (messageIsGeneric) {
    messageStyleClass += ' generic';
  }

  return (
    <div className={`mb-1 ${timeStampSide}`}>
      <div className={`message ${messageSide} ${messageStyleClass}`}>
        {getInnerContent(message)}
      </div>
      {commentMessage &&
        (
          <div className="text-right">
            <small className='grey-text text-lighten-1 created'>
              {commentedTime}
            </small>
            <AnnotationCommentDelete onClick={removeComment} />
          </div>
        )
      }
    </div>
  )
}

export default AnnotationCommentListItem
